import React, { useEffect } from "react";
import { useAccount, resetAccount } from "@repoflow/components/account";
import { Container, Col, Row, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { Fields } from "@repoflow/components/fields";
import AccountSchema from "@common/schema/account/public";
import * as ParamsLib from "@repoflow/browser/params";
import { basename } from "env"


export default function () {
  const account = useAccount();
  const refresh = ParamsLib.urlParameter("refresh");

  useEffect(() => {
    if (refresh) {
      resetAccount();
      window.location = `${basename}/account`;
    }
  }, []);

  if (account === null) {
    return null;
  }

  const {
    status
  } = account;

  return (
    <>


      <Container className="mt-4">
        {status === "validating" && (
          <Row>
            <Col>
              <Alert>
                <p>You need to validate your account.</p>

                <p>
                  Go to the link that we sent to your e-mail to complete the
                  verification.
                </p>
              </Alert>
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <Fields
              schema={AccountSchema}
              target={{ $ref: "/Public/Account/User" }}
              values={{ ...account.user, ...account.organization, ...account.domain }}
              config={{
                "/Public/Account/User": {
                  fields: ["email", "orgId", "domainId"]
                }
              }}

            />
          </Col>
          <Col>
            <Link className="btn btn-secondary" to={"/account/logout"}>
              Logout
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  );
}
